
export const defaultMemberObj = {
  firstNm: '',
  miNm: '',
  lastNm: '',
  dobDt: '',
  ssnNum: '',
  maNum: '',
  gencd: '',
  rshcd: 'SELF',
  recipientPerson: false,
  otherEnrolledResp: '',
  existingMember: false,
  specialCond:'',
  memberPierId: null,
};

export const defaultValidateMemberObj = {
  firstNm: '',
  lastNm: '',
  ssnNum: '',
  dobDt: '',
  pierId: null,
}

export const defaultResAddressObj = {
  addressTypeCd: 'R',
  address1Txt: '',
  address2Txt: '',
  cityTxt: '',
  stateCd: '',
  zipCd: '',
};
export const defaultMailAddressObj = {
  addressTypeCd: 'M',
  address1Txt: '',
  address2Txt: '',
  cityTxt: '',
  stateCd: '',
  zipCd: '',
};
export const defaultResponseDtoObj = {
  referralId: undefined,
  pdfBytes: '',
};

export const defaultFormDtoObj = {
  referralCase: {
    referralSource: '',
    emailTxt: '',
    phone1Num: '',
    phone2Num: '',
    submitterFirstName: '',
    submitterLastName: '',
    existingCase: false,
    updateReason: '',
    paperLess: false,
    emailCommunication: false,
    pierId: null
  },
  referralEmployer: {
    emplyrFein: '',
    emplyrNm: '',
    address1Txt: '',
    address2Txt: '',
    cityTxt: '',
    stateCd: '',
    zipCd: '',
    phone1Num: '',
    emplyrEnrollStartDate: '',
    emplyrEnrollEndDate: '',
    faxNumber:'',

  },
  referralPolicy: {
    sourceCd: '',
    carrierNm: '',
    address1Txt: '',
    address2Txt: '',
    cityTxt: '',
    stateCd: '',
    zipCd: '',
    phone1Num: '',
    planName: '',
    groupNum: '',
    policyNum: '',
    policyStartDate: null,
    policyEndDate: null,
    employeePremium: '',
    frequency: '',
    planTier: '',
    planDeductible: '',
  },
  referralAddressList: [],
  referralMemberList: []

  
};

export const policyHolderCheckFields = [ 'caseVO.referralSource','memberVO.firstNm', 'memberVO.miNm',
        'memberVO.lastNm', 'memberVO.maNum', 'memberObj.ssnNum','d1',
        'memberVO.gencdRf', 'isMemberMedicaid', 'caseVO.addressLine1Txt',
        'caseVO.addressLine2Txt', 'caseVO.cityTxt', 'caseVO.stacdRf',
        'caseVO.zip5Cd', 'caseVO.phone1Num', 'caseVO.phone2Num', 'caseVO.emailTxt', 'isSameMailingAddress',
        'mailAddress.addressLine1Txt', 'mailAddress.addressLine2Txt',
        'mailAddress.cityTxt', 'mailAddress.stacdRf', 'mailing.zip5Cd',
        'mailingState.phone1Num', 'existingMember', 'updateReason',  ];

export const  employerPolicyCheckFields = [ 'isHealthInsurance', 'employerVO.emplyrNm', 'employerVO.addressLine1Txt',
'employerVO.addressLine2Txt', 'employerVO.cityTxt', 'employerVO.stacdRf', 'employerVO.faxNumber',
'employerVO.zip5Cd', 'employerVO.phone1Num', 'employerVO.emplyrFein', 'd8','d9',
'policyVO.carrierNm', 'policyVO.addressLine1Txt', 'policyVO.addressLine2Txt',
'policyVO.cityTxt', 'policyVO.stacdRf', 'policyVO.zip5Cd', 'policyVO.phone1Num',
'policyVO.planName', 'policyVO.policyNum', 'policyVO.groupNum', 'd3',
'premium', 'Deductible', 'policyVO.frequency', 'policyVO.planTier',
 ];

export const  familyMemberCheckFields = [ 'isFamilyMemberMedicate', 'otherfirstNm', 'othermiNm',
        'otherlastNm',  'otherssnNum', 'd6',  'othergencdRf',
        'otherrshcdRf',  'otherEnrolled',  'othermaNum','isOtherMedicaid',];

export const addFamilyMemberFields = [ 'isFamilyMemberMedicate', 'otherfirstNm',  'othermiNm',
'otherlastNm', 'othermaNum', 'otherssnNum', 'd6', 'othergencdRf',
'otherrshcdRf',  'otherEnrolled', 'isOtherMedicaid', ];

export const getDefaultAddress =  {
  addressLine1: '', addressLine2: '', city: '' , state: '', county: '', postalCode: ''
};
